import { SENSOR_STATES } from '@linearb/linjs-common';
import { createSensorAuthorization } from 'state/callers';
import useDispatchify from 'common/hooks/utils/useDispatchify';
import { lbToast } from '@linearb/buzz';
import { getProviderMapBySensorId } from 'common/constants/constants';

interface UseSensorAuthAPIProps {
  sensorId: number;
}

const useSensorAuthAPI = ({ sensorId }: UseSensorAuthAPIProps) => {
  const dispatchCreateSensorAuth = useDispatchify(createSensorAuthorization);

  const sensorMap: any = getProviderMapBySensorId(sensorId);

  if (!sensorMap) {
    throw new Error(`Unknown sensor ID: ${sensorId}`);
  }

  const create = async ({ token, username, name = sensorMap.name }) => {
    try {
      const payload = {
        sensor_id: sensorId,
        name,
        state: SENSOR_STATES.ok,
        token: {
          token
        },
        ...(username && {
          profile: {
            username
          }
        })
      };

      const sensorAuth = await dispatchCreateSensorAuth(payload);
      lbToast({
        title: '',
        description: `${name} integration created successfully`,
        variant: 'success'
      });
      return sensorAuth;
    } catch (error) {
      lbToast({
        title: '',
        description: 'Ooops.. something went wrong',
        variant: 'destructive'
      });
    }
  };

  return {
    create
  };
};

export default useSensorAuthAPI;
